module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/LUcYxb/cover.jpeg?1684979178611",
      "alt": "This image is the cover for the book Come to The Peak, Volume 1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Come to The Peak, Volume 1\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A man with a huge sword on his back, a monkey fighting in the wilderness, and a sparrow with wings covering the sky. So what if he became a demon! So what if he became a Buddha! If I walk my path, why should I fear that the world will judge my skill or my past...He stepped on the Dragon Sparrow Soaring Through Nine Heavens and held the huge sword in his hand as he battled with the Six Paths. Chong Yin was furious because of his beauty. He waved his sword and stained the entire street with his blood. It was normal to call upon the wind and summon the rain. This! This is the life that I, Luo Yu, want. The peak of Ascendant, this life that belongs to you …")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Shi YueLiuNian, Babel Novel\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Funstory\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0